// Jerny color constants — shared across ContentPanel components
export const J = {
  text: "#b0c8e0",
  muted: "#a3d1ff",
  accent: "#66b2ff",
  surface: "#0d1f33",
  border: "0.5px solid #294766",
};

export const typeColor = {
  State: "#4cceac",
  Session: "#66b2ff",
  Decision: "#f0a500",
  Issue: "#ff6b6b",
};
